import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from 'react';
import { ExportPushDrawer, type OpenExportPayload } from './export-push-drawer';

// `null` when a chart is NOT inside a ChartExportSection — then ExportableHighchart
// falls back to its own self-contained (per-chart) push drawer.
const ChartExportSectionContext = createContext<
  ((payload: OpenExportPayload) => void) | null
>(null);

export const useChartExportSection = () =>
  useContext(ChartExportSectionContext);

// Groups charts so they share ONE push drawer that compresses the whole section;
// local state keeps it isolated per section (safe alongside other drawers).
export const ChartExportSection = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  const [state, setState] = useState<OpenExportPayload | null>(null);
  const openExport = useCallback(
    (payload: OpenExportPayload) => setState(payload),
    []
  );
  const close = useCallback(() => setState(null), []);

  return (
    <ChartExportSectionContext.Provider value={openExport}>
      <ExportPushDrawer payload={state} onClose={close} className={className}>
        {children}
      </ExportPushDrawer>
    </ChartExportSectionContext.Provider>
  );
};
